import {createElement, Component, PropTypes} from 'rlink-react';
/*
  Goes into r-link routing
*/
export default function componentView (mapper) {
  // eslint-disable-next-line react/display-name
  return Component => (params, content) => <Component {...mapper(params, content)} />;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/componentViewMapper.jsx